import './Buttons.css';
import './LandingHeader.css';

const LandingHeader = ({ onOpenHelp }) => {
    return (
        <div className="landing-header-wrapper">
            <header className="landing-header">
                <img src="/icons/logo-192.png" alt="Grow Your Food logo" className="landing-header-logo" />

                <h1 className="landing-header-title">GROW YOUR FOOD APP</h1>

                <button className="landing-header-help button" onClick={onOpenHelp }>
                    FAQ
                </button>
            </header>
        </div>
    );
};

export default LandingHeader;

